module.exports = __webpack_public_path__ + "assets/img/img3.7d1526c9.png";